// Thin wrappers around window.location so callers can be unit tested without
// monkey-patching the non-configurable `window.location` object directly.

export function getHostname() {
  return window.location.hostname;
}
export function getPathname() {
  return window.location.pathname;
}
export function getSearch() {
  return window.location.search;
}
export function navigateTo(url) {
  window.location.href = url;
}